import React from 'react';
import { scrollToTemplates } from './Hero';
import OwnezzyLogo from './OwnezzyLogo';
import { LEGAL_CONTACT } from '../legal/contact';

export default function Footer() {
  // On other pages (/about, /terms) the section links open the home page at that section
  const onHome = window.location.pathname.replace(/\/+$/, '') === '';
  const toTemplates = (e) => {
    if (!onHome) return;
    e.preventDefault();
    scrollToTemplates();
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-md-6">
            <a className="brand-mark footer-brand" href={onHome ? '#top' : '/'} aria-label="Ownezzy">
              <OwnezzyLogo className="footer-logo" />
            </a>
            <p>Simple websites for small businesses ready to sell online.</p>
          </div>
          <div className="col-md-6 text-md-end">
            <a href={onHome ? '#top' : '/'}>Home</a>
            <a href="/websites">All Websites</a>
            <a href={onHome ? '#plans' : '/#plans'}>Plan</a>
            <a href="/partner">Partner</a>
            <a href="/about">About Us</a>
            <a href="/blog">Blog</a>
            <a href="/guide">User Guide</a>
            <a href="/contact">Contact Us</a>
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
            <a href="/refund-policy">Refund Policy</a>
            <a href="/delivery-policy">Delivery Policy</a>
            <p className="copyright">© 2026 Ownezzy, operated by {LEGAL_CONTACT.operator} (sole proprietor), India. All rights reserved. Prices in Indian Rupees (₹).</p>
          </div>
        </div>
      </div>
    </footer>
  );
}